import { BrowserStorageCache } from '@aws-amplify/cache';

/*******************************************************************************
 * app-cache.js exposes session and local storage caches and the keys to the
 * items in the caches
 ******************************************************************************/

/**
 * The keys for items stored in the cache
 */
const cacheKeys = {
  auth_state: 'auth_state',
  code_verifier: 'code_verifier',
  refresh_token: 'refresh_token',
  token: 'token',
  user: 'user',
  survery_content: 'survey_content',
};

/**
 * The keyprefix to use for the caches
 */
const keyPrefix = 'agent-ui-';

/**
 * A localStorage cache for the application
 */
const localCache = BrowserStorageCache.createInstance({
  capacityInBytes: 5242880, // 5 MB
  itemMaxSize: 2621440,     // 2.5 MB
  keyPrefix,
});

/**
 * A sessionStorage cache for the application
 */
const sessionCache = BrowserStorageCache.createInstance({
  keyPrefix,
  storage: window.sessionStorage,
});

/**
 * Helper function to clear both local and session cache
 */
const clearCache = () => {
  localCache.clear();
  sessionCache.clear();
};

/**
 * Clear both local and session cache and reload
 */
const clearCacheAndReload = () => {
  clearCache();
  window.location.reload();
};

/**
 * Removes an item from the cache and returns its value
 * @param {import('@aws-amplify/cache').BrowserStorageCache} cacheObj The cache object to pop the item from
 * @param {string} key The key of the cached item
 */
const popCacheItem = (cacheObj, key) => {
  const rtn = cacheObj.getItem(key);
  cacheObj.removeItem(key);
  return rtn;
};

/*******************************************************************************
 * exported api definition
 ******************************************************************************/
export {
  cacheKeys,
  clearCache,
  clearCacheAndReload,
  localCache,
  popCacheItem,
  sessionCache,
};
